import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import {
  TransformedStatsData,
  usePatchEstablishmentStatsPermissionsMutation,
} from '../util/useEstablishmentStatsQuery'

import { StatSquare } from './StatSquare'

export type Props = {
  data: TransformedStatsData
  refData: TransformedStatsData[]
  setShowLoaderOverlay: (state: boolean) => void
  canPersonEdit: boolean
}

export const AdminSquare: React.FC<Props> = ({
  data,
  refData,
  setShowLoaderOverlay,
  canPersonEdit,
}) => {
  const queryClient = useQueryClient()
  const patchEstablishmentStatsPermissions =
    usePatchEstablishmentStatsPermissionsMutation(queryClient)

  const handleIsPublicUpdate = (stats: TransformedStatsData) => {
    setShowLoaderOverlay(true)
    patchEstablishmentStatsPermissions.mutate(
      {
        stat_key: stats.permissionKey,
        is_public: !stats.isPublic,
      },
      { onSettled: () => setShowLoaderOverlay(false) },
    )
  }

  const adminSquareProps = {
    toggleFeature: handleIsPublicUpdate,
    setShowLoaderOverlay,
  }

  return (
    <StatSquare
      adminSquareProps={canPersonEdit ? adminSquareProps : undefined}
      data={data}
      refData={refData}
    />
  )
}
